
import { defineComponent } from "vue";
import { trans } from "@/globals/translator";
import Icon from "@moonlight/vue3/components/Icon.vue";
import config from "@/config";

export default defineComponent({
  components: {
    Icon,
  },
  setup() {
    const links = [
      {
        text: trans("general.watch_filmin"),
        href: process.env.VUE_APP_FILMIN_WEB_LINK,
      },
      {
        text: trans("general.contact"),
        to: "Contact",
      },
      {
        text: trans("general.register"),
        to: "Register",
      },
    ];

    const socialLinks = [
      { icon: "facebook", href: config.FACEBOOK_LINK },
      { icon: "twitter", href: config.TWITTER_LINK },
      { icon: "instagram", href: config.INSTAGRAM_LINK },
      { icon: "linkedin", href: config.LINKEDIN_LINK },
      { icon: "pinterest", href: config.PINTEREST_LINK },
    ];

    return { links, socialLinks };
  },
});
